import React from 'react';
import PropTypes from 'prop-types';
import { H3 } from 'components/core/Typography';
import { Link } from 'components/core/Link';
import { Section, Container, Column, Row } from 'components/core/Page';
import GTM_CLASSNAMES from 'utils/gtmSelectors';
import './Cities.scss';
export function Cities({ title, cities }) {
	return (
		<Section>
			<Container>
				<Row>
					<Column>
						<div className="near-by-cities">
							<H3
								weight="extraBold"
								size="medium"
							>
								{title}
							</H3>
							<div className="cities">
								{cities.map(({ slug, name }) => (
									<Link
										key={slug}
										href={slug}
										className={GTM_CLASSNAMES.CITY_LINK}
										quaternary
									>
										{name}
									</Link>
								))}
							</div>
						</div>
					</Column>
				</Row>
			</Container>
		</Section>
	);
}
Cities.propTypes = {
	title: PropTypes.string,
	cities: PropTypes.arrayOf(PropTypes.object),
};
export default Cities;
